import { Link } from 'react-router-dom';

export default function Footer() {
  const currentYear = new Date().getFullYear();

  const navColumns = [
    {
      title: '快速导航',
      links: [
        { label: '首页', path: '/' },
        { label: '漫画分类', path: '/category/romance' },
        { label: '排行榜', path: '/#ranking' },
        { label: '最新更新', path: '/#latest' },
      ],
    },
    {
      title: '热门分类',
      links: [
        { label: '恋爱言情', path: '/category/romance' },
        { label: '奇幻冒险', path: '/category/fantasy' },
        { label: '热血动作', path: '/category/action' },
        { label: '惊悚恐怖', path: '/category/horror' },
      ],
    },
    {
      title: '关于我们',
      links: [
        { label: '品牌介绍', path: '/about' },
        { label: '联系我们', path: '/about#contact' },
        { label: '用户协议', path: '/about' },
        { label: '隐私政策', path: '/about' },
      ],
    },
  ];

  return (
    <footer className="bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="relative py-14 md:py-16">
          <div className="absolute -top-6 left-0 w-20 h-20 bg-secondary-500/10 rounded-2xl rotate-12"></div>
          <div className="absolute -bottom-4 right-8 w-16 h-16 bg-primary-500/10 rounded-2xl -rotate-12"></div>

          <div className="relative bg-background-50 rounded-2xl px-6 md:px-10 py-10 md:py-12">
            <div className="flex flex-col lg:flex-row gap-10 lg:gap-16">
              <div className="lg:w-1/4">
                <Link to="/" className="inline-block">
                  <span className="font-heading text-2xl font-bold tracking-tight text-foreground-950">
                    ManhwaFun
                  </span>
                </Link>
                <p className="mt-4 text-sm text-foreground-500 leading-relaxed">
                  韩漫画免费阅读平台，提供海量韩国漫画资源。支持下拉式阅读体验，更新及时，画质高清。让您轻松追更，享受阅读乐趣。
                </p>
                <div className="mt-5 flex items-center gap-3">
                  <a
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200"
                    aria-label="微博"
                    rel="nofollow"
                  >
                    <i className="ri-weibo-line"></i>
                  </a>
                  <a
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200"
                    aria-label="微信"
                    rel="nofollow"
                  >
                    <i className="ri-wechat-line"></i>
                  </a>
                  <a
                    href="#"
                    className="w-9 h-9 flex items-center justify-center rounded-full bg-background-200 text-foreground-600 hover:bg-primary-500 hover:text-background-50 transition-colors duration-200"
                    aria-label="QQ"
                    rel="nofollow"
                  >
                    <i className="ri-qq-line"></i>
                  </a>
                </div>
              </div>

              <div className="flex-1 grid grid-cols-2 md:grid-cols-3 gap-8">
                {navColumns.map((column) => (
                  <div key={column.title}>
                    <h4 className="text-sm font-semibold text-foreground-950 uppercase tracking-wide mb-4">
                      {column.title}
                    </h4>
                    <ul className="flex flex-col gap-2.5">
                      {column.links.map((link) => (
                        <li key={link.label}>
                          <Link
                            to={link.path}
                            className="text-sm text-foreground-500 hover:text-primary-500 transition-colors duration-200"
                          >
                            {link.label}
                          </Link>
                        </li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-background-300/60 py-5 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-400">
            &copy; {currentYear} ManhwaFun. All rights reserved.
          </p>
          <div className="flex items-center gap-4 text-xs text-foreground-400">
            <Link to="/about" className="hover:text-foreground-600 transition-colors">
              用户协议
            </Link>
            <span className="text-foreground-300">|</span>
            <Link to="/about" className="hover:text-foreground-600 transition-colors">
              隐私政策
            </Link>
            <span className="text-foreground-300">|</span>
            <Link to="/about" className="hover:text-foreground-600 transition-colors">
              联系我们
            </Link>
          </div>
        </div>
      </div>
    </footer>
  );
}